import { Injectable, signal, computed } from '@angular/core';
import { FilterSidebarConfig, FilterGroup } from '../models';

@Injectable({ providedIn: 'root' })
export class FilterSidebarService {
  private isOpen = signal(false);
  private config = signal<FilterSidebarConfig | null>(null);
  private resolver: ((result: FilterGroup[] | null) => void) | null = null;

  readonly state = computed(() => ({
    isOpen: this.isOpen(),
    config: this.config(),
  }));

  open(config: FilterSidebarConfig): Promise<FilterGroup[] | null> {
    this.config.set(config);
    this.isOpen.set(true);

    return new Promise((resolve) => {
      this.resolver = resolve;
    });
  }

  apply(result: FilterGroup[]): void {
    this.isOpen.set(false);
    this.resolver?.(result);
    this.resolver = null;
    this.config.set(null);
  }

  close(): void {
    this.isOpen.set(false);
    this.resolver?.(null);
    this.resolver = null;
    this.config.set(null);
  }
}
